"use client"

import styled from "@emotion/styled"
import { replaceRichTextLinks } from "utils"
import { TickCircleIcon } from "../icons"

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-block: 40px;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 40px;
  }
`

const StyledTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: -0.8px;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
  text-transform: capitalize;
  width: 100%;

  span {
    color: #0000fa;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 40px;
  }
`

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 24px;
  }
`

const StyledIntro = styled.div`
  margin: 0;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 18px;
  }

  * {
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`

const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

const StyledItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: #0000fa;
  }
`

const StyledItemText = styled.span`
  flex: 1;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.port.defaultTextColor};

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 16px;
  }
`

type ImportantPointsProps = {
  blackTitle: string
  blueTitle: string
  intro: string
  items: any[]
}

export default function ImportantPoints({
  blackTitle,
  blueTitle,
  intro,
  items,
}: ImportantPointsProps) {
  if (!items || items.length === 0) return null

  return (
    <StyledSection>
      <StyledTitle>
        {blackTitle} <span>{blueTitle}</span>
      </StyledTitle>
      <StyledContent>
        {intro && (
          <StyledIntro
            dangerouslySetInnerHTML={{
              __html: replaceRichTextLinks(intro),
            }}
          />
        )}
        <StyledList>
          {items.map((item: any, index: number) => {
            return (
              <StyledItem key={index}>
                <TickCircleIcon />
                <StyledItemText>{item}</StyledItemText>
              </StyledItem>
            )
          })}
        </StyledList>
      </StyledContent>
    </StyledSection>
  )
}
